var _path, _mask, _path2, _path3, _mask2, _path4, _path5, _mask3, _path6, _path7, _mask4, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLicensingPeriod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 5.79086 5.79086 4 8 4H57C59.2091 4 61 5.79086 61 8V20H4V8Z",
    stroke: "#4230E5",
    strokeWidth: 8
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_670_4365",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24H65V57C65 61.4183 61.4183 65 57 65H8C3.58172 65 0 61.4183 0 57V24Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24H65H0ZM73 57C73 65.8366 65.8366 73 57 73H8C-0.836556 73 -8 65.8366 -8 57H8H57H73ZM8 73C-0.836556 73 -8 65.8366 -8 57V24H8V57V73ZM73 24V57C73 65.8366 65.8366 73 57 73V57V24H73Z",
    fill: "#4230E5",
    mask: "url(#path-2-inside-1_670_4365)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 8C83.5 4.96243 85.9624 2.5 89 2.5H138C141.038 2.5 143.5 4.96243 143.5 8V21.5H83.5V8Z",
    stroke: "#B8B5DD",
    strokeWidth: 5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_670_4365",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 24H146V57C146 61.4183 142.418 65 138 65H89C84.5817 65 81 61.4183 81 57V24Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24H146H81ZM151 57C151 64.1797 145.18 70 138 70H89C81.8203 70 76 64.1797 76 57H86C86 58.6569 87.3431 60 89 60H138C139.657 60 141 58.6569 141 57H151ZM89 70C81.8203 70 76 64.1797 76 57V24H86V57C86 58.6569 87.3431 60 89 60V70ZM151 24V57C151 64.1797 145.18 70 138 70V60C139.657 60 141 58.6569 141 57V24H151Z",
    fill: "#B8B5DD",
    mask: "url(#path-5-inside-2_670_4365)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 89C2.5 85.9624 4.96243 83.5 8 83.5H57C60.0376 83.5 62.5 85.9624 62.5 89V102.5H2.5V89Z",
    stroke: "#B8B5DD",
    strokeWidth: 5
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-3_670_4365",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 105H65V138C65 142.418 61.4183 146 57 146H8C3.58172 146 0 142.418 0 138V105Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 105H65H0ZM70 138C70 145.18 64.1797 151 57 151H8C0.820298 151 -5 145.18 -5 138H5C5 139.657 6.34315 141 8 141H57C58.6569 141 60 139.657 60 138H70ZM8 151C0.820298 151 -5 145.18 -5 138V105H5V138C5 139.657 6.34315 141 8 141V151ZM70 105V138C70 145.18 64.1797 151 57 151V141C58.6569 141 60 139.657 60 138V105H70Z",
    fill: "#B8B5DD",
    mask: "url(#path-8-inside-3_670_4365)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 89C83.5 85.9624 85.9624 83.5 89 83.5H138C141.038 83.5 143.5 85.9624 143.5 89V102.5H83.5V89Z",
    stroke: "#B8B5DD",
    strokeWidth: 5
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-4_670_4365",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 105H146V138C146 142.418 142.418 146 138 146H89C84.5817 146 81 142.418 81 138V105Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81 105H146H81ZM151 138C151 145.18 145.18 151 138 151H89C81.8203 151 76 145.18 76 138H86C86 139.657 87.3431 141 89 141H138C139.657 141 141 139.657 141 138H151ZM89 151C81.8203 151 76 145.18 76 138V105H86V138C86 139.657 87.3431 141 89 141V151ZM151 105V138C151 145.18 145.18 151 138 151V141C139.657 141 141 139.657 141 138V105H151Z",
    fill: "#B8B5DD",
    mask: "url(#path-11-inside-4_670_4365)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLicensingPeriod);
export default __webpack_public_path__ + "static/media/no-licensing-period.c1096fd967f1b7ac9d892b4749243b89.svg";
export { ForwardRef as ReactComponent };